module.exports = "/_next/static/files/b316eda82360a27aeceb1abdec57d1c0.png";